var _path, _rect, _rect2, _rect3, _rect4, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueCompendiumLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4133 20C43.1748 20 45.4133 17.7614 45.4133 15C45.4133 12.2386 43.1748 10 40.4133 10C37.6519 10 35.4133 12.2386 35.4133 15C35.4133 17.7614 37.6519 20 40.4133 20Z",
    fill: "#07CC9E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 4.16333,
    y: 3.75,
    width: 72.5,
    height: 20,
    rx: 3.75,
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 4.16333,
    y: 30,
    width: 72.5,
    height: 20,
    rx: 3.75,
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 4.16333,
    y: 56.25,
    width: 72.5,
    height: 20,
    rx: 3.75,
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4133,
    y: 60,
    width: 10,
    height: 10,
    rx: 0.833333,
    fill: "#C30B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.876 35.291C40.1272 34.903 40.6995 34.903 40.9507 35.291L45.3112 42.026C45.5838 42.4469 45.2787 43 44.7739 43H36.0528C35.548 43 35.2429 42.4469 35.5154 42.026L39.876 35.291Z",
    fill: "#FF9C2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueCompendiumLogo);
export default __webpack_public_path__ + "static/media/value-compendium-logo.a83d18cb0c1effa06c41d65d3aa3e3be.svg";
export { ForwardRef as ReactComponent };